let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bKV2M")).then(() => parcelRequire('626CG'));